import { useEffect, useState } from 'react';
import { sendGlobalTrackingThunk } from '../../../redux/core/thunks.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { generateFacebookTrackingPayload } from './generateFacebookTrackingPayload.js';
import { rememberMeSelector } from '../../../views/Login/loginSlice.js';
import { activeWrapperSelector, twoStepTrackingComponentStateSelector, } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
import { modifyUtagDataAfterLoginsAndRegistrations } from '../../tools.js';
export const useSendFacebookTrackingScript = (formType) => {
    const [trackingEventState, setTrackingEventState] = useState('initial');
    const dispatch = useAppDispatch();
    const checkboxState = useAppSelector(rememberMeSelector);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const twoStepComponentState = useAppSelector(twoStepTrackingComponentStateSelector);
    useEffect(() => {
        if (trackingEventState !== 'initial') {
            (async () => {
                if (trackingEventState === 'loginSuccess' ||
                    trackingEventState === 'registrationSuccess') {
                    await modifyUtagDataAfterLoginsAndRegistrations();
                }
                const [payloadGeneratingFunction, payloadOverwrites] = generateFacebookTrackingPayload(trackingEventState, formType, checkboxState, activeWrapper, twoStepComponentState);
                dispatch(sendGlobalTrackingThunk(payloadGeneratingFunction, payloadOverwrites));
            })();
        }
    }, [trackingEventState]);
    return { setTrackingEventState };
};
//# sourceMappingURL=useSendFacebookTracking.js.map